import $ from "jquery";
import SimpleBar from "simplebar";


export const Map = function () {
	if (!($("#map").length > 0)) return false;

	// Initialize SimpleBar on map container
	const mapContainer = document.querySelector('.map__body-container');
	let simpleBarInstance = null;
	if (mapContainer) {
		simpleBarInstance = new SimpleBar(mapContainer, {
			autoHide: false, // Always show scrollbar
			forceVisible: true, // Force scrollbar to be visible
			clickOnTrack: true // Allow clicking on track to scroll
		});
	}

	const $elms = {
		pinchNotif: $(".js-pinch-notif"),
		wrapper: $("#event-map"),
		element: $("#map-img"),
		btnBack: $(".js-back-btn"),
		zoomIn: $(".js-zoom-in"),
		zoomOut: $(".js-zoom-out"),
		zoomText: $(".map__zoom-text"),
		legendsBtn: $(".js-legends-btn"),
		legendsContainer: $(".js-legends-container"),
		zoomWrapper: $(".js-map-zoom"),
		imageWrapper: $(".js-map-wrapper"),
		appElement: $("#event-map"),
	};

	let zoomLevel = 1;
	const ZOOM_STEP = 0.1;
	const ZOOM_MIN = 1;
	const ZOOM_MAX = 2;

	let lastTouchDistance = null;

	function getTouchDistance(touches) {
		const dx = touches[0].clientX - touches[1].clientX;
		const dy = touches[0].clientY - touches[1].clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}

	$elms.appElement.on(
		"touchstart",
		function (e) {
			if (e.touches.length > 1) {
				e.preventDefault();
			}
		},
		{ passive: false },
	);

	$elms.appElement.on(
		"gesturestart",
		function (e) {
			e.preventDefault();
		},
		{ passive: false },
	);

	$elms.element.on("touchstart", function (e) {
		if (e.touches.length === 2) {
			lastTouchDistance = getTouchDistance(e.touches);
			localStorage.setItem("pinch-map", 1);
			$($elms.pinchNotif).removeClass("is-active");
		}
	});

	$elms.element.on("touchmove", function (e) {
		if (e.touches.length === 2 && lastTouchDistance) {
			const newDistance = getTouchDistance(e.touches);
			const delta = newDistance - lastTouchDistance;

			const SENSITIVITY = 0.005;
			const newZoom = zoomLevel + delta * SENSITIVITY;

			setZoom(newZoom);

			lastTouchDistance = newDistance;
			e.preventDefault();
		}
	});

	$elms.element.on("touchend", function (e) {
		if (e.touches.length < 2) {
			lastTouchDistance = null;
		}
	});

	const setZoom = (level) => {
		zoomLevel = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, level));

		const levelText = Math.round(zoomLevel * 100);
		if (levelText < 100) {
			$elms.element.css({
				width: "auto",
				height: `${zoomLevel * 100}%`,
			});
		} else {
			$elms.element.css({
				width: "auto",
				height: `${zoomLevel * 100}%`,
			});
		}

		// Recalculate SimpleBar scrollbar after zoom change
		if (simpleBarInstance) {
			simpleBarInstance.recalculate();
		}

		$elms.zoomText.text(`${levelText}%`);
		$elms.zoomWrapper.toggleClass("is-active", zoomLevel > 1);
		$elms.imageWrapper.toggleClass("is-zoomed", zoomLevel < 1);
	};

	const toggleLegends = () => {
		$($elms.legendsContainer).toggleClass("is-active");
	};

	const mapPinched = localStorage.getItem("pinch-map") || 0;
	if (mapPinched != 1) {
		$($elms.pinchNotif).addClass("is-active");
	}

	$($elms.wrapper).on("click", function () {
		localStorage.setItem("pinch-map", 1);
		$($elms.pinchNotif).removeClass("is-active");
	});

	$($elms.btnBack).on("click", function () {
		if (
			window.history.length > 1 &&
			document.referrer.indexOf(window.location.origin) === 0
		) {
			window.history.back();
		} else {
			window.location.href = "/";
		}
	});

	$($elms.zoomIn).on("click", function () {
		setZoom(zoomLevel + ZOOM_STEP);
	});

	$($elms.zoomOut).on("click", function () {
		setZoom(zoomLevel - ZOOM_STEP);
	});

	$($elms.legendsBtn).on("click", function () {
		$(this).toggleClass("is-active");
		toggleLegends();
	});
};
